module.exports = __webpack_public_path__ + "static/media/26UNRWA23.b9515fb3.jpg";